// extracted by mini-css-extract-plugin
module.exports = {"swatchPicker":"Rt","thumbWrap":"St","selectedSwatch":"Tt","swatchThumbnail":"Ut","swatchThumbnailPlaceholder":"Vt"};